function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1716 1.79111C17.621 1.23583 16.9662 0.795006 16.2448 0.493993C15.5235 0.192979 14.7499 0.037709 13.9684 0.0371094C12.4903 0.0373513 11.0661 0.593382 9.97792 1.59511C8.88983 0.593213 7.4656 0.0371559 5.98744 0.0371094C5.20506 0.0379251 4.43056 0.193669 3.70852 0.495378C2.98648 0.797087 2.33115 1.2388 1.78025 1.79511C-0.569508 4.15811 -0.568509 7.85411 1.78224 10.2071L9.97792 18.4141L18.1736 10.2071C20.5244 7.85411 20.5254 4.15811 18.1716 1.79111Z"
});

var SvgSingleheart = function SvgSingleheart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSingleheart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/singleheart.a76c03dc.svg";
export { ForwardRef as ReactComponent };